import React from 'react';
import { Image,Group} from 'react-konva';


const PointVector =   React.forwardRef(({posX,posY,latexImage,magX,magY,groupRef,onDragEnd,onDragStart,index,onVectorMouseDown},ref) => {


    const onMouseLeave = () => {

    }

    const onMouseDown = (evnt) => {
        onVectorMouseDown({evnt,arrowHeadClicked:false,index});
    }

  
    const onDragEndLocal = () => {
        if(groupRef && groupRef.current)
            onDragEnd({x:groupRef.current.x(),y:groupRef.current.y()});
    }

  
    const onDragStartLocal = () => {
        onDragStart({index:index});
    }

    return <React.Fragment>
            <Group  onMouseLeave={onMouseLeave} x={posX} y={posY} height={magX} width={magY}
                ref={groupRef}
                draggable
                onDragStart={onDragStartLocal}
                onDragEnd={onDragEndLocal}
                onTouchEnd={onMouseLeave}
                onMouseDown={onMouseDown}
                >
                    <Image
                        x ={0}
                        y ={0}
                        image={latexImage}    
                        height={magX} 
                        width={magY}
                    />
            </Group>
        </React.Fragment>
});

export default PointVector;